module.exports = __webpack_public_path__ + "static/media/BalancoFinanc3.d53f349e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelBalancoFinanc/BalancoFinanc3.png
// module id = 2173
// module chunks = 0